import { render, staticRenderFns } from "./datacenter.vue?vue&type=template&id=5040a2a2&scoped=true&"
import script from "./datacenter.vue?vue&type=script&lang=js&"
export * from "./datacenter.vue?vue&type=script&lang=js&"
import style0 from "./datacenter.vue?vue&type=style&index=0&id=5040a2a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5040a2a2",
  null
  
)

export default component.exports